import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { CreateQuarterNameConfigRequest, QuarterNameConfig, QuarterNameConfigsResponse } from "src/app/domain/models/QuarterNameConfig";


@Injectable({providedIn: 'root'})
export abstract class QuarterNameConfigGateway{

  abstract create(request: CreateQuarterNameConfigRequest): Observable<QuarterNameConfig[]>
  abstract update(request: CreateQuarterNameConfigRequest): Observable<QuarterNameConfig[]>
  abstract getByStock(stockId: number): Observable<QuarterNameConfig[]>
  abstract getConfigs(stockId: number): Observable<QuarterNameConfigsResponse>
}
